import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class VisionStepCriteria extends BasicCriteria {
chronoCode: string;
visionCode: string;
}

